/* eslint-disable */
import React, { useLayoutEffect } from "react";
import { CriticalIllnessBrochure, GlobeLifeLogo } from "../../../../../assets";
import BrochureRenderer from "../../../../shared/brochureRenderer/BrochureRenderer";
import VEBCriticalIllnessImage from "../../../../../assets/VEBPlanImages/VEBCriticalIllnessImage.avif";
import "./criticalIllness.scss";

const CriticalIllness: React.FC = (): JSX.Element => {
	useLayoutEffect(() => {
		window.scrollTo(0, 0);
	});
	return (
		<div className="critical-illness-main-container">
			<div className="main-landing-container">
				<div className="left-section">
					<h3 className="main-benefits-title">Crittical Illness Plan</h3>
					<div className="powered-by-logo-container">
						<span>Powered By</span>
						<img src={GlobeLifeLogo} alt="" />
					</div>
					<div className="plan-description">
						<span>
							You may know someone who has been affected by a critical illness such as cancer, stroke or
							heart attack and witnessed the resulting challenges. Are you prepared it a critical illness
							were to happen to you? MedMutual Protect Critical Illence insurance can help you when you
							need it most.
						</span>

						<h3>Stay focused on getting well</h3>
						<span>
							A Globe Life Critical Illness Insurance policy gives you an extra layer of
							financial security during these tough times—providing benefits that you can use to help keep
							the bills paid and protect your savings. That way, your focus can be on getting better.
						</span>
					</div>
				</div>
				<div className="right-section">
					<img src={VEBCriticalIllnessImage} alt="VEBCriticalIllnessImage" />
				</div>
			</div>
			<h3 className="sub-heading-title">Plan Brochure</h3>

			<div className="brochure-renderer-container" style={{ overflow: "hidden" }}>
				<BrochureRenderer brochure={CriticalIllnessBrochure} />
			</div>
		</div>
	);
};

export default CriticalIllness;
